module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "apply-detail-steps-wrap"
  }, [_c('el-steps', {
    staticClass: "apply-detail-steps",
    attrs: {
      "active": _vm.active,
      "direction": "vertical"
    }
  }, [_c('el-step', {
    attrs: {
      "title": _vm.$T('填写秩序册'),
      "description": _vm.$T('联系人、邮箱与电话')
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.$T('联系人、邮箱与电话')))]), _vm._v(" "), (_vm.row.memberstatus > 0 && _vm.row.memberstatus < 6) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink.replace",
      value: ({
        name: 'ISaiApplyFormStep1',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep1',query:{id:row.id}}",
      modifiers: {
        "replace": true
      }
    }],
    attrs: {
      "size": "small",
      "round": ""
    }
  }, [_vm._v(_vm._s(_vm.$T('修改信息')))]) : _vm._e()], 1)]), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.$T('人员信息'),
      "description": _vm.$T('队伍成员与证件')
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.$T('队伍成员与证件')))]), _vm._v(" "), (_vm.row.memberstatus > 1 && _vm.row.memberstatus < 6) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink.replace",
      value: ({
        name: 'ISaiApplyFormStep2',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep2',query:{id:row.id}}",
      modifiers: {
        "replace": true
      }
    }],
    attrs: {
      "size": "small",
      "round": ""
    }
  }, [_vm._v(_vm._s(_vm.$T('修改信息')))]) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus == 1) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep2',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep2',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$T('继续操作')))]) : _vm._e()], 1)]), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.$T('住宿预订'),
      "description": _vm.hasRoomStep ? _vm.$T('酒店与房型') : _vm.$T('线上赛区无需填写')
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.hasRoomStep ? _vm.$T('酒店与房型') : _vm.$T('线上赛区无需填写')))]), _vm._v(" "), (_vm.hasRoomStep) ? [(_vm.row.memberstatus > 1 && _vm.row.memberstatus < 6) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep3',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep3',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": ""
    }
  }, [_vm._v(_vm._s(_vm.$T('修改信息')))]) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus == 1) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep3',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep3',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$T('继续操作')))]) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus >= 3 && _vm.row.memberstatus < 6) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep3RoomMember',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep3RoomMember',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": ""
    }
  }, [_vm._v(_vm._s(_vm.$T('房间分配')))]) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.$T('餐饮预订'),
      "description": _vm.$T('用餐与套餐')
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.$T('用餐与套餐')))]), _vm._v(" "), (_vm.row.memberstatus > 2 && _vm.row.memberstatus < 6) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep4',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep4',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": ""
    }
  }, [_vm._v(_vm._s(_vm.$T('修改信息')))]) : _vm._e(), _vm._v(" "), (_vm.mealShowContinue) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep4',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep4',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$T('继续操作')))]) : _vm._e()], 1)]), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.$T('接送服务'),
      "description": _vm.$T('接机/送站')
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.$T('接机/送站')))]), _vm._v(" "), (_vm.row.memberstatus >= 4 && _vm.row.memberstatus < 6) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep5',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep5',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": ""
    }
  }, [_vm._v(_vm._s(_vm.$T('修改信息')))]) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus >= 2 && _vm.row.memberstatus < 4) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep5',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep5',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$T('继续操作')))]) : _vm._e()], 1)]), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.$T('签证邀请'),
      "description": _vm.$T('签证信息填报')
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.$T('签证信息填报')))]), _vm._v(" "), (_vm.row.memberstatus >= 5 && _vm.row.memberstatus < 5) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep6',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep6',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": ""
    }
  }, [_vm._v(_vm._s(_vm.$T('修改信息')))]) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus >= 2 && _vm.row.memberstatus < 5) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep6',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep6',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$T('继续操作')))]) : _vm._e()], 1)]), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.$T('国歌上传'),
      "description": _vm.$T('队伍国歌音频')
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.$T('队伍国歌音频')))]), _vm._v(" "), (_vm.row.memberstatus >= 5 && _vm.row.memberstatus < 5) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep7',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep7',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": ""
    }
  }, [_vm._v(_vm._s(_vm.$T('修改信息')))]) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus >= 2 && _vm.row.memberstatus < 5) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep7',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep7',query:{id:row.id}}"
    }],
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$T('继续操作')))]) : _vm._e()], 1)]), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.$T('报名完成'),
      "description": _vm.$T('报名与后续事项')
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.$T('报名与后续事项')))])])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07405030","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyDetail.vue
// module id = 1309
// module chunks = 0